/**
 * Cache-busting token for statically served assets fetched at runtime
 * (translation JSON, above all).
 *
 * The problem it solves: `outputHashing` only fingerprints JS and CSS, NEVER
 * files under `assets/`. So `/assets/i18n/es.json` keeps the same URL forever,
 * the browser serves its cached copy, and edited translations do not show up
 * until the user manually clears their cache. In production that means a text
 * fix can stay invisible to users indefinitely.
 *
 * Appending this as a query param makes each app load request a URL the browser
 * has not seen, so it refetches instead of serving a stale copy. The value is
 * fixed for the lifetime of the page — it is evaluated once at module load —
 * so a single session still hits the HTTP cache normally and lang switching
 * does not cause repeat downloads.
 *
 * A build-time constant (git SHA) would be tighter, but nothing in the current
 * Nx/Docker pipeline injects one, and a hand-maintained version in
 * `environment.ts` is exactly the kind of thing that silently goes stale — the
 * same failure this exists to prevent.
 */
export const ASSET_VERSION = String(Date.now());

/** Appends `ASSET_VERSION` as a `v` query param to an asset URL. */
export function versionedAssetUrl(url: string): string {
  return `${url}${url.includes('?') ? '&' : '?'}v=${ASSET_VERSION}`;
}
